import { MarkedReleaseNoteRow } from "../../services/release_note";
import * as ReduxToolkit from "@reduxjs/toolkit";

export interface State {
    releaseNotes?: MarkedReleaseNoteRow[];
}

export function initState(): State {
    return {};
}

export const releaseNoteSlice = ReduxToolkit.createSlice({
    name: "releaseNotes",
    initialState: initState(),
    reducers: {
        resetState: (state) => {
            state = initState();
            return state;
        },
        updateReleaseNotes: (
            state,
            action: ReduxToolkit.PayloadAction<MarkedReleaseNoteRow[]>
        ) => {
            state.releaseNotes = action.payload;
            return state;
        },
    },
});
